/**
 * Static placeholder ads (local assets). Enable with REACT_APP_SIMIMOVIES_STATIC_ADS=1
 */
export const SIMIMOVIES_STATIC_ADS_ENABLED = process.env.REACT_APP_SIMIMOVIES_STATIC_ADS === '1';

/**
 * Fetches /api/v1/ads/placements and merges with static fallbacks. Enable with REACT_APP_SIMIMOVIES_MANAGED_ADS=1
 */
export const SIMIMOVIES_MANAGED_ADS_ENABLED = process.env.REACT_APP_SIMIMOVIES_MANAGED_ADS === '1';

export function adSurfaceEnabled() {
  return SIMIMOVIES_STATIC_ADS_ENABLED || SIMIMOVIES_MANAGED_ADS_ENABLED;
}
